



























































































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'

// Mixin
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

// Models
import CardModel from '@/_models/CardModel'

// Interfaces
import { IDropdownList } from '@/_interfaces'

// Helpers
import { Constant } from '@/_services/constant'
import { Filter } from '@/_utils/filter'
import { convertJBOXType } from '@/_utils/card'
import { CARD_CSV_FIELD } from '@/_consts/CSVFields'

// Components
import SearchUser from '@/components/shared/SearchUser.vue'
import SearchFloor from '@/components/shared/SearchFloor.vue'
import SearchSanID from '@/components/shared/SearchSanID.vue'
import TablePagination from '@/components/shared/TablePagination.vue'
import NotFound from '@/components/common/NotFound.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'
import ActionButtonsGroup from '@/components/common/buttons/ActionButtonsGroup.vue'
import CardEditModal from './modals/CardEditModal.vue'
import CardImportCSVModal from './modals/CardImportCSVModal.vue'

@Component({
  components: {
    SearchFloor,
    SearchUser,
    SearchSanID,
    NotFound,
    TablePagination,
    DropdownSearch,
    ActionButtonsGroup,
    CardEditModal,
    CardImportCSVModal,
  },
  computed: {
    ...mapGetters('cards', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('cards', {
      canDelete: 'canDelete',
    }),
  },
})
export default class CardList extends mixins(TableSortMixin) {
  canEdit!: () => boolean
  canDelete!: () => boolean

  // data
  filterUtilTableSort: any = new Filter('filter_card_list_table_sort')
  filterUtilPage: any = new Filter('filter_cardlist_page')
  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'san_id',
    searchQuery: '',
  }

  numofPage: number = 1
  selected: any = {}
  isFormModalActive: boolean = false
  isImportCsvModalActive: boolean = false
  isSearchUserActive: boolean = false
  isSearchSanIDActive: boolean = false

  sanIdsErrors: string[] = []

  filedNameLUT: any = {
    _id: 'UUID',
    san_id: 'label.san_id',
    user_name: 'label.username',
    user_id: 'label.user_id',
    category_name: 'label.category_name',
  }

  // Import/Export csv setting
  csvFields: string[] = CARD_CSV_FIELD

  dropdownList: IDropdownList[] = [
    {
      value: 'san_id',
      label: this.$t('label.san_id').toString(),
    },
    {
      value: 'user_name',
      label: this.$t('label.username').toString(),
    },
    {
      value: 'category_name',
      label: this.$t('label.category_name').toString(),
    },
  ]

  // computed
  get cards(): CardModel[] {
    const cards = this.$store.state.cards.all.items
    this.numofPage = Math.ceil(cards.length / this.pageFilters.perPage)

    return cards
  }

  get isNew(): boolean {
    return !this.selected._id
  }

  get isLoading(): boolean {
    return this.$store.state.cards.loading
  }

  get selectedUser(): object {
    return {
      _id: this.selected.user_id,
      name: this.selected.user_name,
    }
  }

  get selectedSanID(): object {
    return {
      san_id: this.selected.san_id,
    }
  }

  get filteredData(): CardModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.cards) {
      return []
    }

    return this.cards.filter((item: any): boolean => {
      return (
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1 ||
        item._id === this.pageFilters.searchQuery // Can search by uuid
      )
    })
  }

  get selectedFloor(): object {
    return {
      _id: this.selected.floor_id,
      name: this.selected.floor_name,
    }
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new CardModel(Constant.CARD_TYPE_CARRIED)
  }

  selectedUserDone(data): void {
    this.selected.user_id = data._id
    this.selected.user_name = data.name
    this.selected.category_name = data.category_name
    this.isSearchUserActive = false
  }

  selectedSanIDDone(data): void {
    this.selected.san_id = data.san_id
    this.selected.jcard_type = convertJBOXType(data.jbox_type)

    this.isSearchSanIDActive = false
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }
      if (this.isNew) {
        // add item
        this.$store.dispatch('cards/addOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('cards/updateOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  confirmCustomDelete(data): void {
    this.selected = data

    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        // Delete row
        const index = this.cards.indexOf(this.selected)
        await this.$store.dispatch('cards/deleteOne', this.selected)
        this.selected = {}
        this.$buefy.toast.open(this.$t('messages.delete_success') as string)
      },
    })
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)

    this.$store.dispatch('cards/getAll', {
      card_type: Constant.CARD_TYPE_CARRIED,
    })
  }
}
